import React from 'react';
import { useField, FieldAttributes } from 'formik';
import { TextField, TextFieldProps } from '@mui/material';

export type FormTextFieldProps = TextFieldProps & FieldAttributes<any>;

export const FormTextField: React.FC<FormTextFieldProps> = ({ name, ...props }) => {
    if (!name) {
        throw new Error('FormTextField requires a name prop');
    }

    const [field, meta] = useField(name);
    
    return (
        <TextField
            {...field}
            {...props}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
            fullWidth
            margin="normal"
            variant="outlined"
        />
    );
};
